import { Loader } from "@/components/ui/loader";

export const LoadingPage = () => {
  return (
    <main className="min-h-screen w-full flex flex-col items-center justify-center relative">
      {/* Background pattern */}
      <div className="fixed inset-0 bg-[url('/grid.svg')] bg-center [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))] opacity-[0.02]" />
      
      <div className="relative flex flex-col items-center justify-center gap-6 p-8 bg-primary/5 backdrop-blur-xl border border-primary/10 rounded-2xl">
        <Loader size="lg" className="text-primary" />
        <h1 className="text-xl font-medium text-foreground">
          Cargando
          <span className="animate-pulse">...</span>
        </h1>
        <p className="text-sm text-muted-foreground/80">
          Preparando todo para ti
        </p>
      </div>
    </main>
  );
};